import React from 'react';
import { DatePicker } from 'components/Input';
import utils from 'utils';

interface Props {
  value: string;
  onChange: (value: string | number) => void;
  dateFormat?: string;
}

export default (props: Props) => {
  const { value, onChange, dateFormat } = props;
  return (
    <DatePicker
      inputWidth="100%"
      selected={value ? utils.date.convertToObjectDate(value) : null}
      isClearable
      fontSize={12}
      portal
      noBorder
      dateFormat={dateFormat}
      disabled={false}
      onChange={(newDate) => onChange(newDate ? utils.date.formatDateForDb(newDate) : '')}
      height="26px"
    />
  );
};
